import React from "react";
import FileSingleComponent from "../uploads/FileSingleComponent";

const DayLightFactorSetup = () => {
  const userId = localStorage.getItem("userID");
  const token = localStorage.getItem("token");
  const projectID = localStorage.getItem("projectID");
  const apiRoot = process.env.REACT_APP_API_ROOT;
  return (
    <div>
      <FileSingleComponent
        heading1="Upload Your Window Zip File"
        heading2="Digital Twin File Uploader"
        fileUploadComponents={[
          {
            label: "Window Zip File",
            id: "scene-setup",
            uploadUrl: `${apiRoot}/project/setup/?project_id=${projectID}&user_id=${userId}&file_type=daylight`,
          },
        ]}
      />
    </div>
  );
};

export default DayLightFactorSetup;
